import {
    observable,
    action,
    toJS,
    runInAction
} from 'mobx';
import {ViewBase} from 'mutants-appfx';
import {Message} from 'tplus-components-touch';
import _clonedeep from 'lodash/cloneDeep'

class Weigh extends ViewBase {
    get type(){
    return 'Weigh';
    }

    @observable visible=false;
    @observable title;
    @observable body;
    @observable cancelEnable
    output

    constructor(store,name){
        super(store,name);
    }

    @action async init({title,data,autoCancel}){
        await runInAction(()=>{
            this.title=title;
            this.body=data;
            this.show();
        })
        if( !isNaN(autoCancel)){
            setTimeout(() => {
                this.hide();
            }, Number(autoCancel));
        }
    }

    @action show(){
        this.visible=true
    }

    @action hide(){
        this.visible=false
    }

    @action ok=()=>{
        this.hide();
        this.output(this.body)
    }

    @action cancel=()=>{
        this.hide();
        this.output();
    }

    static fromJS(store) {
        return new Weigh(store, 'Weigh');
    }
}
export default Weigh;
